import styled from 'styled-components';

export const StyledRecordedCourseVideoPage = styled.div`
  width: 100%;
`;